import React, { useState, useMemo } from "react";
import styles from "./TableView.module.css";
import { Spinner } from "@/shared/components/common/Spinner/Spinner";
interface TableViewProps {
  data: Record<string, React.ReactNode>[];
  loading?: boolean
}

const TableView: React.FC<TableViewProps> = ({ data, loading }) => {
  const [sortKey, setSortKey] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | null>(null);

  const handleHeaderClick = (header: string) => {
    if (sortKey !== header) {
      setSortKey(header);
      setSortOrder("asc");
    } else if (sortOrder === "asc") {
      setSortOrder("desc");
    } else if (sortOrder === "desc") {
      setSortKey(null);
      setSortOrder(null);
    } else {
      setSortOrder("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!sortKey || !sortOrder) return data;
    const sorted = [...data].sort((a, b) => {
      const aValue = a[sortKey];
      const bValue = b[sortKey];
      const aStr = typeof aValue === "string" || typeof aValue === "number" ? aValue : String(aValue);
      const bStr = typeof bValue === "string" || typeof bValue === "number" ? bValue : String(bValue);
      if (aStr < bStr) return sortOrder === "asc" ? -1 : 1;
      if (aStr > bStr) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [data, sortKey, sortOrder]);
  const headers = data && data.length > 0 ? Object.keys(data[0]) : [];

  // Если загрузка или нет данных, показываем таблицу с заголовками и одной строкой
  if (loading || !data || data.length === 0) {
    return (
      <div className={styles.container}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tr}>
              {headers.length > 0
                ? headers.map((header) => (
                    <th key={header} className={styles.th}>
                      {header}
                    </th>
                  ))
                : <th className={styles.th}>Данные</th>
              }
            </tr>
          </thead>
          <tbody>
            <tr className={styles.tr}>
              <td className={styles.td} colSpan={headers.length > 0 ? headers.length : 1} style={{ textAlign: 'center' }}>
                {loading ? (
                  <><span>Получение данных </span><Spinner /></>
                ) : (
                  'Нет данных для отображения'
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tr}>
            {headers.map((header) => (
              <th
                key={header}
                className={styles.th}
                onClick={() => handleHeaderClick(header)}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                {header}
                {sortKey === header && sortOrder === "asc" && " \u2191"}
                {sortKey === header && sortOrder === "desc" && " \u2193"}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row, idx) => (
            <tr key={idx} className={styles.tr}>
              {headers.map((header) => (
                <td key={header} className={styles.td}>
                  {row[header]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableView; 